//============================================================================
// Name        : ls_compare.ts
// Purpose     : Implement actions on Lightspeed compare page
// Created     : 2020-03-24
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import { InitPage } from "../index";
import { LsDownload } from "./ls_download";
import { LsSync } from "./ls_sync";
import { LsSyncCategories } from "./ls_sync_categories";

declare const integrationErrors: string;
declare const lsSyncInProgress: boolean;
declare const lsPreviewDataUrl: string;

export interface LsProgressChannelData {
  message: string;
  inProgress: boolean;
  progress: number;
  state: string;
  success: boolean;
}

class LsCompare {
  lsDownload: LsDownload;
  lsSync: LsSync;
  lsSyncCategories: LsSyncCategories;

  constructor() {
    this.lsDownload = new LsDownload();
    this.lsSync = new LsSync();
    this.lsSyncCategories = new LsSyncCategories();

    // If there are errors on the integration configuration, we'll display a dialog instead of the normal flow
    if (integrationErrors != "") {
      $(".action-ls-download").on("click", () => { this.showIntegrationErrors(); });
      $(".action-ls-sync").on("click", () => { this.showIntegrationErrors(); });
      $(".action-ls-category-sync").on("click", () => { this.showIntegrationErrors(); });
      return;
    }

    // console.log("lsSyncInProgress:", lsSyncInProgress);
    // Bind sync actions
    if (lsSyncInProgress == true) {
      this.lsDownload.connectLScable(this.lsDownload.dialogId, (data: LsProgressChannelData) => {
        $("#ls_sync_progress").text(data.message);
        $("#ls_dl_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress == null ? 100 : data.progress}%`);
        $("#dlProgressLabel").text(`${data.progress == null ? 100 : data.progress}%`);
        $("#ProgressLabel").text(`${data.progress == null ? 100 : data.progress}%`);
        if ((!data.inProgress) && (data.success) && (data.message == "Updated the store ls preview sync identifier")) {
          window.location.reload();
        }
      });
    }
    $(".action-ls-download").on("click", () => { this.lsDownload.show(); });
    $(".action-ls-sync").on("click", () => {
      this.lsSync.show();
      if (!$("#syncDialog").data("full-cycle-count-required")) {
        $("#redownload-checkbox").show();
      }
    });
    $(".action-ls-category-sync").on("click", () => { this.lsSyncCategories.show(); });

    this.fetch_preview_data();
  }

  showIntegrationErrors() {
    $("#integrationErrorsDialog .errors").html(integrationErrors);
    $("#integrationErrorsDialog").modal("show");
  }

  fetch_preview_data() {
    axios.get(lsPreviewDataUrl)
      .then(function(resp) {
        if (resp.status == 200) {
          $('#count_of_all_lightspeed_import').prop('title', `${resp.data.count_of_all_lightspeed_import} Record(s)`);
          $("#last_sync_time").text(resp.data.last_sync_time);
          $("#last_dl_time").text(resp.data.last_dl_time);
          $("#last_full_cycle_count").text(resp.data.last_full_cycle_count);
          $("#last_bulk_import_qty").text(resp.data.last_bulk_import_qty);
          $('#last_sync_count').prop('title', `${resp.data.last_sync_count} Record(s)`);

          if (resp.data.last_dl_failed) {
            $("#last_dl_time").text("FAILED");
            $("#last_dl_time").css('color', 'red');
          } else {
            $('#last_download_success').text('success');
          }
        }
      })
      .catch(function(error) {
        console.error(error);
      });

  }
}

export function LoadPage() {
  InitPage("compare_v2", () => {
    if ($("body").hasClass("sync_preview")) {
      return;
    }
    const lsCompare = new LsCompare();
  });
}
